module.exports = __webpack_public_path__ + "static/media/bulk_couriers_mark_deliver_sample.eeb39da3.csv";